/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Amount_SprayingInputs */

const vi_care_log_amount_spraying = /** @type {(inputs: Care_Log_Amount_SprayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng đã phun`)
};

/**

* @param {Care_Log_Amount_SprayingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_amount_spraying = /** @type {((inputs?: Care_Log_Amount_SprayingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Amount_SprayingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_amount_spraying(inputs)
});